var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInfo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.54688 0C3.24688 0 0.546875 2.7 0.546875 6C0.546875 9.3 3.24688 12 6.54688 12C9.84688 12 12.5469 9.3 12.5469 6C12.5469 2.7 9.84688 0 6.54688 0ZM6.84688 2.14286C7.3183 2.14286 7.74687 2.52857 7.74687 3.04286C7.74687 3.55714 7.36116 3.94286 6.84688 3.94286C6.37545 3.94286 5.94688 3.55714 5.94688 3.04286C5.94688 2.52857 6.33259 2.14286 6.84688 2.14286ZM6.37545 10.2429C5.60402 10.2429 5.04688 9.51429 5.26116 8.78571L6.03259 6.21429C6.1183 5.91429 5.90402 5.65714 5.60402 5.65714H5.2183C5.43259 5.01429 6.03259 4.58571 6.7183 4.58571C7.48973 4.58571 8.04688 5.31429 7.83259 6.04286L7.06116 8.61429C6.97545 8.91429 7.18973 9.17143 7.48973 9.17143H7.87545C7.66116 9.81429 7.06116 10.2429 6.37545 10.2429Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInfo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/info.b08e5b85583413b04dc971d1b7ee4462.svg";